import type { ContentIdStatus, MusicSourceKind, Track } from '@qlk/shared';
import { SAP_HET_HAN_NGAY } from '@qlk/shared';

import { ngayDay, soNgayConLai, type Tone } from '../../../ui/index.js';

/**
 * Định dạng riêng của màn Kho nhạc.
 *
 * Ngày giờ và số ngày còn lại dùng bản chung ở `apps/web/src/ui/dinhDang.ts`
 * (gộp ở bước 12.2) — bản cũ ở đây hard-code `'Asia/Ho_Chi_Minh'` thay vì dùng
 * `APP_TIMEZONE`.
 */

export { ngayDay as ngayVn, ngayGioNgan as ngayGioVn, soNgayConLai } from '../../../ui/dinhDang.js';

/** `212 → "3:32"`; `612 → "10:12"`. Theo cột "Dài" trong ảnh thiết kế. */
export function doDai(giay: number): string {
  if (!Number.isFinite(giay) || giay <= 0) return '—';
  const phut = Math.floor(giay / 60);
  const con = Math.floor(giay % 60);
  return `${String(phut)}:${String(con).padStart(2, '0')}`;
}

export const TONE_CONTENT_ID: Record<ContentIdStatus, Tone> = {
  registered: 'ok',
  pending: 'warn',
  not_registered: 'neutral',
};

export const TONE_NGUON: Record<MusicSourceKind, Tone> = {
  own: 'info',
  partner: 'neutral',
  network_library: 'warn',
};

/**
 * Cột "Giấy phép" trong ảnh: nhạc Miss Records ghi "Sở hữu", nhạc kho Network
 * ghi "Theo HĐ Network", nhạc đối tác ghi "Đến dd/MM/yyyy" (đỏ khi sắp hết).
 */
export function nhanGiayPhep(bai: Pick<Track, 'sourceKind' | 'licenseEndDate'>): {
  text: string;
  mau: string;
} {
  if (!bai.licenseEndDate) {
    return bai.sourceKind === 'own'
      ? { text: 'Sở hữu', mau: 'text-ok-chu' }
      : { text: 'Theo HĐ Network', mau: 'text-ok-chu' };
  }

  const conLai = soNgayConLai(bai.licenseEndDate) ?? 0;
  const mau =
    conLai < 0 ? 'text-bad-chu' : conLai <= SAP_HET_HAN_NGAY ? 'text-warn-chu' : 'text-ok-chu';
  return { text: `${conLai < 0 ? 'Hết hạn' : 'Đến'} ${ngayDay(bai.licenseEndDate)}`, mau };
}
